"use client";

import { useHits, useInstantSearch } from "react-instantsearch";

import type { CatalogProduct, Locale } from "@/domain/catalog/product";
import {
	isListingEligible,
	toListingProduct,
	type ListingProduct
} from "@/domain/product-listing";

export interface UseListingProductsResult {
	products: ListingProduct[];
	isInitialLoad: boolean;
}

export function useListingProducts(locale: Locale): UseListingProductsResult {
	const { items } = useHits<CatalogProduct>();
	const { status } = useInstantSearch();

	const isInitialLoad = status === "loading" && items.length === 0;

	const products = items
		.filter((hit) => isListingEligible(hit))
		.map((hit) => toListingProduct(hit, locale));

	return { products, isInitialLoad };
}
